import {patchState, signalStore, withComputed, withMethods, withState} from '@ngrx/signals';
import {computed} from '@angular/core';

import {withDevtools} from '@angular-architects/ngrx-toolkit';

import {Perspective} from '@selpia/shared/models';

export interface PerspectiveState {
  perspective: Perspective | undefined;
}

const initialPerspectiveState: PerspectiveState = {
  perspective: undefined,
};

export const PerspectiveStore = signalStore(
  {providedIn: 'root'},
  withDevtools('perspective-store'),
  withState(initialPerspectiveState),
  withComputed(({perspective}) => ({
    focusDimensionLevel: computed(() => perspective()?.focusDimensionLevel),
  })),
  withMethods((store) => ({
    setPerspective(perspective: Perspective): void {
      patchState(store, {perspective});
    },
  })),
);

export type PerspectiveStore = InstanceType<typeof PerspectiveStore>;
